export default __webpack_public_path__ + "static/media/img1.a2cf4256.png";